import { render, staticRenderFns } from "./Preventive.vue?vue&type=template&id=372e45e1&scoped=true"
import script from "./Preventive.vue?vue&type=script&lang=js"
export * from "./Preventive.vue?vue&type=script&lang=js"
import style0 from "./Preventive.vue?vue&type=style&index=0&id=372e45e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e45e1",
  null
  
)

export default component.exports